<template>
  <div>
    <Fancybox :options="{
      Carousel: {
        infinite: true,
      },
    }">

      <div class="relative mt-s40">
        <a data-fancybox="gallery" :href="thumbnail">
          <img :src="thumbnailLarge" width="420" height="637" :alt="alt" />
        </a>

        <div class="absolute text-center text-white -top-s5 -right-s5 w-fit grid gap-s5">
          <div v-for="(item, index) in stickers" :key="index" class="py-s3 text-t12 uppercase rounded-md w-s140"
            :class="'sticker-' + item.sticker_color">
            {{ item.title }}</div>
        </div>
      </div>

    </Fancybox>
  </div>
</template>

<script>
import Fancybox from './Fancybox.vue';

export default {
  name: "ProductImages",
  components: {
    Fancybox,
  },
  props: [
	  'thumbnail',
	  'thumbnailLarge',
    'stickers',
	  'alt'
  ],
};
</script>